import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useModal } from '@/providers/modal';
import { ModalSwipeLayout } from '@/kit/Modal/layouts/swipe';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { getPeriodOptions } from '@/components/TaxReport/PeriodSelect/utils';
import IconCheck from './icon_check.svg';
import s from './index.module.scss';

const id = MODAL_IDS.period_select_modal;

export const PeriodSelectModal = props => {
  const { modalIds } = useModal();
  return modalIds[id] && <Modal {...props} />;
};

export const Modal = ({ range, onChange }) => {
  const { closeModal } = useModal();
  const { t } = useTranslation('reports');

  const options = getPeriodOptions(t);

  const selected = range ? range.join(':') : '';

  const content = (
    <div className={s.modal}>
      <h1 className="f-article-accent">{t('date_picker.period')}</h1>
      <div className={s.content}>
        <div className={s.list}>
          {options.map(option => (
            <div
              className={classnames(s.item, 'f-body-regular')}
              key={option.value}
              onClick={() => {
                onChange(option);
                closeModal(id);
              }}
            >
              {option.label}
              {selected === option.value && (
                <img src={IconCheck} alt="check" width={24} height={24} />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <ModalSwipeLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalSwipeLayout>
  );
};
